export default __webpack_public_path__ + "static/media/confetti.dd3f1acf.gif";